/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js";

export default {
  getList({ commit }, { id, query }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`students/${id}/freezings?${new URLSearchParams(query)}`)
        .then((response) => {
          commit("SET_LIST", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getDetail({ commit }, { id, query }) {
    return new Promise((resolve, reject) => {
      axios
        .get(`master/freezings/${id}?${new URLSearchParams(query)}`)
        .then((response) => {
          commit("SET_DETAIL", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  create({ commit }, { student_id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .post(`students/${student_id}/freezings`, payload)
        .then((response) => {
          commit("CREATE_SUCCESS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  update({ commit }, { student_id, freezing_id, payload }) {
    return new Promise((resolve, reject) => {
      axios
        .put(`students/${student_id}/freezings/${freezing_id}`, payload)
        .then((response) => {
          commit("UPDATE_SUCCESS", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
